<script setup>
import {useDate} from '@/composables/use-date.js'
import {dateFormats} from '@/constants/date-and-time.js'
import {toRefs} from 'vue'

//Props
const props = defineProps({
  date: {
    type: [Object, String],
    default: null,
  },
  format: {
    type: String,
    default: dateFormats.DATE,
  },
  emptyLabel: {
    type: String,
    default: '',
  },
})

//Composables
const {date, format} = toRefs(props)
const {formattedDate} = useDate(date, format)
</script>

<template>
  <span>{{ formattedDate || emptyLabel }}</span>
</template>
